var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.wrongVersion)?_c('i18n',{staticClass:"pa-4 yellow black--text",attrs:{"path":"reloadAdvice","tag":"div"}},[_c('a',{staticStyle:{"text-decoration":"underline"},on:{"click":_vm.reload}},[_c('b',[_vm._v(_vm._s(_vm.$t('reloadAdviceClickHere')))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }